import React, { useEffect, useState } from 'react';
import { Bar } from 'react-chartjs-2'; // Import Bar from 'react-chartjs-2' instead of 'chart.js/auto'
import AxiosClient from '../assets/AxiosClient';
import Loader from '../assets/tools/Loder/loader';

const AttendanceStatistics = ({ date }) => {
  const [statistics, setStatistics] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await AxiosClient.get(`/Dashborad/AttendanceStatistics/${date}`);
        setStatistics(response.data);
      } catch (error) {
        console.error(error);
      }
    };

    fetchData();
  }, [date]);

  if (!statistics) {
    return <Loader label="Loading statistics..." />;
  }

  const { totalAttendance, inPersonAttendance, remoteAttendance } = statistics;
  
  const data = {
    labels: ['number of in Person Attendance', 'number of Remote Attendance'],
    datasets: [
      {
        label: 'Attendance Statistics',
        data: [ inPersonAttendance, remoteAttendance],
        backgroundColor: [
          'rgba(54, 162, 235, 0.6)',
          'rgba(255, 99, 132, 0.6)',
        ],
      },
    ],
  };

  const options = {
    scales: {
      y: {
        beginAtZero: true,
        precision: 0,
      },
    },
  };

  return (
    <div>
      <h2>Attendance Statistics for {date}</h2>
      <Bar data={data} options={options} />
    </div>
  );
};

export default AttendanceStatistics;